export async function registerChatServiceWorker() {
    if (!("serviceWorker" in navigator) || !("Notification" in window))
        return null;
    const registration = await navigator.serviceWorker.register("/sw-chat.js");
    return registration;
}
export async function requestNotificationPermission() {
    if (!("Notification" in window))
        return false;
    if (Notification.permission === "granted")
        return true;
    if (Notification.permission === "denied")
        return false;
    const result = await Notification.requestPermission();
    return result === "granted";
}
export function showLocalNotification(title, body, channelId, registration) {
    registration.showNotification(title, {
        body,
        icon: "/favicon.ico",
        tag: channelId,
        data: { channelId },
    });
}
let lastSoundTime = 0;
const SOUND_DEBOUNCE_MS = 3000;
/** Два коротких тона, Гц: восходящий «дзинь». */
const CHIME_TONES = [880, 1320];
const TONE_SECONDS = 0.14;
const TONE_GAIN = 0.25;
let audioContext = null;
/**
 * Звук нового сообщения (UC1005). WP-DSP-FIX-01: раньше играл `public/notification.mp3`, но файл был пустым (0 байт)
 * с момента появления чата — звука не было никогда. Теперь сигнал синтезируется Web Audio API, ресурса нет.
 * Браузер разрешает звук только после действия пользователя на странице; до него сигнал молча не играет.
 */
export function playNotificationSound() {
    const now = Date.now();
    if (now - lastSoundTime < SOUND_DEBOUNCE_MS)
        return;
    lastSoundTime = now;
    try {
        const AudioContextClass = window.AudioContext ?? window.webkitAudioContext;
        if (!AudioContextClass)
            return;
        audioContext = audioContext ?? new AudioContextClass();
        const ctx = audioContext;
        if (ctx.state === "suspended")
            ctx.resume().catch(() => { });
        const startAt = ctx.currentTime;
        CHIME_TONES.forEach((frequency, index) => {
            const oscillator = ctx.createOscillator();
            const gain = ctx.createGain();
            const toneStart = startAt + index * TONE_SECONDS;
            oscillator.type = "sine";
            oscillator.frequency.value = frequency;
            gain.gain.setValueAtTime(0.0001, toneStart);
            gain.gain.exponentialRampToValueAtTime(TONE_GAIN, toneStart + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, toneStart + TONE_SECONDS);
            oscillator.connect(gain).connect(ctx.destination);
            oscillator.start(toneStart);
            oscillator.stop(toneStart + TONE_SECONDS);
        });
    }
    catch {
        // Звук необязателен: без Web Audio остаются бейдж и системное уведомление
    }
}
